import React, { useState } from "react";
import styled from "@emotion/styled";
import OptionDoble from "../../../../shared/OptionDoble";

const SimpleQuestionComponent = ({ config, question, actions }) => {
    const Wrapper = {
        width: "100%"
    };

    const Title = {
        width: "calc(75% - 4vh)",
        borderRadius: "1vh",
        backgroundColor: "#3C3C3B",
        color: "white",
        fontSize: "3.5vh",
        padding: "2vh",
        textAlign: "center",
        fontWeight: "bold",
    }

    const OptionsWrapper = {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        margin: "1vh 0",
        padding: "3vh 0",
        overflow: "hidden",
        columnGap: "2vh",
        rowGap: "2vh"
    };


    const Option = styled.div`
        ${props => `
            flex: 1 1 calc(${props.multipleRow ? "50%" : "100%"} - 5vh);
            border-radius: 1vh;
            font-size: 2.5vh;
            text-align: center;
            padding: 1.5vh;
            font-weight: bold;
            cursor: pointer;

            ${props.selected ? `
                animation-name: select;
                background: #3C3C3B;
                color: white;
                font-weight: bold;
            ` : `
                background: white;
                animation-name: none;
            `};
        `};
    `;

    const Option2 = styled.div`
        ${props => `
            flex: 1 1 calc(${props.multipleRow ? "50%" : "100%"} - 5vh);
            padding: 1.5vh;
        `};
    `;

    const HorizontalWrapper = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    };

    const Button = styled.button`
        width: 20%;
        border-radius: 1vh;
        border: none;
        background-color: ${actions.isAnySelectedOption() ? "#00963f" : "#3C3C3B"};
        color: white;
        font-size: 2.7vh;
        padding: 1vh;
        text-align: center;
        font-weight: bold;
        pointer-events: auto; 
        cursor: pointer;

        ${actions.isAnySelectedOption() ? "animation-name: activate; animation-iteration-count: infinite; animation-duration: 0.6s; animation-timing-function: linear; animation-direction: alternate; @keyframes activate {from { transform: scale(1.0); } to { transform: scale(0.95); }}" : ""}
    `;

    const Subtitle = {
        width: "100%",
        borderRadius: "1vh",
        color: "white",
        fontSize: "3.5vh",
        padding: "1vh",
        textAlign: "center",
        fontWeight: "bold",
        marginTop: "2vh"
    }

    const Image = styled.img`
        margin-left: 1vh;
        width: 1vw;
        height: 1.8vh;
    `;

    return (
        <div style={Wrapper}>
            <div style={HorizontalWrapper}>
                <div style={Title}>
                    {config.getTranslatedText(question?.questionTitle)}
                </div>
                <Button onClick={actions.timeForward}>Ok<Image src={require(`../../../../../assets/images/btn_flecha_write.png`)} /></Button>
            </div>
            {
                actions.isMultipleOptionAllowed() ?
                    <div style={Subtitle}>
                        {config.getText("multipleOption")}
                    </div> : <></>
            }
            <div style={OptionsWrapper}>
                {(question?.options || []).map((option, i) => {
                    if(option?.suboptions.length !== 0){
                        return (
                            <OptionDoble key={"option" + i}
                                selected={option?.selected}
                                multipleRow={question?.options?.length > 5}
                                onClick={() => { 
                                    config.popupInputAlert(config.getTranslatedText(option?.option), i, option?.suboptions, actions, config,);
                                }}
                                option={option}
                                config={config}>
                            </OptionDoble>
                        );
                    }
                    else{
                        return (
                            <Option key={"option" + i}
                                selected={option?.selected}
                                multipleRow={question?.options?.length > 5}
                                onClick={() => { actions.selectOption(i) }}>
                                {config.getTranslatedText(option?.option)}
                            </Option>
                        );
                    }
                })}
                {(question?.options?.length % 2) == 1 ? (<Option2 multipleRow={question?.options?.length > 5} />) : (null)}
            </div>
        </div>
    );
};

export default SimpleQuestionComponent;
